module.exports = __webpack_public_path__ + "static/media/TaskInactive.b32b0b85.png";